import { styled } from '@mui/material';

import { ElementType } from 'react';

import { Typography } from '../../../Typography';

export type TitleProps = {
  title: string;
  component?: ElementType;
};

const StyledHeader = styled(Typography)({
  fontSize: 14,
  lineHeight: 1.5,
  fontWeight: 500,
});

export const SectionHeader = ({ title, component }: TitleProps) => {
  return <StyledHeader component={component || 'h3'}>{title}</StyledHeader>;
};
